import { render } from "./TabMenu.vue?vue&type=template&id=1f783797&scoped=true"
import script from "./TabMenu.vue?vue&type=script&lang=js"
export * from "./TabMenu.vue?vue&type=script&lang=js"

import "./TabMenu.vue?vue&type=style&index=0&id=1f783797&lang=scss&scoped=true"

import exportComponent from "D:\\workpace\\yt-portal-layout\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f783797"]])

export default __exports__